export default [
  { to: '/legos', display: 'Legos', contributorsAllowed: true },
  { to: '/tasks', display: 'Tasks', contributorsAllowed: true },
  { to: '/manuals', display: 'Manuals', contributorsAllowed: true },
  { to: '/models', display: 'Models', contributorsAllowed: true },
  { to: '/dataviews', display: 'Dataviews' },
  { to: '/stats', display: 'Stats' },
  { to: '/emails', display: 'Emails', contributorsAllowed: true },
  { to: '/tagging', display: 'Tags' },
  { to: '/facets', display: 'Facets' },
  { to: '/trims', display: 'Trims' },
  // { to: '/users', display: 'Users' },
  { to: '/crawl', display: 'Crawling', contributorsAllowed: true },
  { to: '/scripts', display: 'Scripts' },
  { to: '/security', display: 'Security' },
  { to: '/cerokm', display: '0km', onlyDomain: ["localhost", "legos.startmycar.com", "local.opinautos.com"] },
  { to: '/test', display: '🧪' },
]
